import React from "react";
import { Box, Flex, Text, Button } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Header = () => {
  return (
    <Box bg="blue.500" py={4}>
      <Flex
        maxW="900px"
        mx="auto"
        px={4}
        justifyContent="space-between"
        alignItems="center"
      >
        <motion.div
          style={{
            height: "8vh",
            padding:"2px"
          }}
          animate={{
            translateY: "20px",
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: "reverse",
          }}
        >
          <Text
          
            as="h1"
            fontSize="xl"
            fontWeight="bold"
            fontFamily="Pacifico, cursive"
            color="white"
          >
            Dream Cream
          </Text>
        </motion.div>
        <Flex>
          <motion.div
            style={{
              marginRight: "1rem",
            }}
            animate={{
              translateY: "20px",
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatType: "reverse",
              delay: 0.5,
            }}
          >
            <Button
              as={Link}
              to="/"
              variant="ghost"
              color="white"
              fontWeight="bold"
              fontFamily="Pacifico, cursive"

            >
              Home
            </Button>
          </motion.div>
          <motion.div
            style={{
              marginRight: "1rem",
            }}
            animate={{
              translateY: "20px",
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatType: "reverse",
              delay: 0.7,
            }}
          >
            <Button
              as={Link}
              to="/coins"
              variant="ghost"
              color="white"
              fontWeight="bold"
              fontFamily="Pacifico, cursive"

            >
              Coins
            </Button>
          </motion.div>
          <motion.div
            animate={{
              translateY: "20px",
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatType: "reverse",
              delay: 1,
            }}
          >
            <Button
              as={Link}
              to="/exchanges"
              variant="ghost"
              color="white"
              fontWeight="bold"
              fontFamily="Pacifico, cursive"

            >
              Exchanges
            </Button>
          </motion.div>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Header;
